<app-map-to-search class="h100"
        (mapReady)="mapReady($event)"
        (dragEnd)="dragEnd($event)"
        [center]="center$|async"
        [pointer]="pointer$|async"
        [markers]="(markers$|async)!"
        (clickMap)="clickMap($event)"

>
</app-map-to-search>
<div style="position: absolute;right: 80px;bottom: 45px;width: calc(100% - 110px)">
    <mat-card>
        <mat-dialog-content class="flex-around-center flex-direction-row " style="display: flex">
            <mat-form-field appearance="fill" style="margin-bottom: -19px;width: calc(100% - 100px)">
                <mat-label>{{ 'search'|translate }}</mat-label>
                <input appGetGoogleAddress
                       (changeAddress)="setSearchAddress($event)"
                       matInput type="text">
            </mat-form-field>
            <button mat-mini-fab color="accent" style="width: 40px" [mat-dialog-close]="undefined">
                <mat-icon>clear</mat-icon>
            </button>
            <button mat-mini-fab color="primary" style="width: 40px" (click)="closeDialog()"
                    [disabled]="!(pointIsSet$|async)">
                <mat-icon>check</mat-icon>
            </button>
        </mat-dialog-content>
    </mat-card>
</div>

